export default __webpack_public_path__ + "static/infographic-mightyc-arrows-789ab13797abbe52d93af749eb0dcf33.svg";